module.exports = new __parcel__URL__("co2--dataset-cover.53546d25.jpg").toString();